/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  class ExpandableText extends HTMLElement {
    constructor() {
      super();
      this.height = parseInt(this.getAttribute('data-height'));
      this.content = this.querySelector('.expandable-text__content');
      this.button = this.querySelector('.expandable-text__button');
      if (this.content.clientHeight < this.height) {
        this.classList.add('expanded');
      }
    }

    connectedCallback() {
      this.button.addEventListener('click', this.toggle.bind(this));
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      this.classList.toggle('expanded');
    }
  }

  if (!customElements.get('expandable-text')) {
    customElements.define('expandable-text', ExpandableText);
  }

  const customizeVideos = () => {
    document.querySelectorAll('video:not([data-video-customized])').forEach(video => {
      const hideCustomPlayControls = video.closest('[data-show-custom-play-controls="false"]');
      const hideCustomSoundControls = video.closest('[data-show-custom-sound-controls="false"]');
      const hideCustomControls = video.closest('deferred-media');

      video.setAttribute('data-video-customized', 'true');

      if (!!hideCustomControls || (!!hideCustomPlayControls && !!hideCustomSoundControls)) {
        return;
      }

      video.removeAttribute('controls');
    
      if (!video.parentElement.classList.contains('video-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'video-wrapper';
        video.parentNode.insertBefore(wrapper, video);
        wrapper.appendChild(video);
      }
      const wrapper = video.parentElement;
    
      const controls = document.createElement('div');
      controls.className = 'video-controls';
    
      const playPauseBtn = document.createElement('button');
      playPauseBtn.className = 'control-button';
    
      const muteBtn = document.createElement('button');
      muteBtn.className = 'control-button';

      if (!hideCustomPlayControls) {
        controls.appendChild(playPauseBtn);
      }
      if (!hideCustomSoundControls) {
        controls.appendChild(muteBtn);
      }
      wrapper.appendChild(controls);
    
      // Function to update play/pause button state
      function updatePlayPauseButton() {
        playPauseBtn.innerHTML = video.paused ?
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd" /></svg>' :
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path fill-rule="evenodd" d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z" clip-rule="evenodd" /></svg>';
      }
    
      // Function to update mute button state
      function updateMuteButton() {
        muteBtn.innerHTML = video.muted ? 
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM17.78 9.22a.75.75 0 1 0-1.06 1.06L18.44 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L20.56 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z" /></svg>' :
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6"><path d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 0 0 1.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06ZM18.584 5.106a.75.75 0 0 1 1.06 0c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 0 1-1.06-1.06 8.25 8.25 0 0 0 0-11.668.75.75 0 0 1 0-1.06Z" /><path d="M15.932 7.757a.75.75 0 0 1 1.061 0 6 6 0 0 1 0 8.486.75.75 0 0 1-1.06-1.061 4.5 4.5 0 0 0 0-6.364.75.75 0 0 1 0-1.06Z" /></svg>';
      }
    
      // Initial update (respects autoplay and mute state)
      updatePlayPauseButton();
      updateMuteButton();
    
      playPauseBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play().then(() => {
            updatePlayPauseButton();
          }).catch(() => {
            // Handle play rejection e.g. autoplay not allowed
            updatePlayPauseButton();
          });
        } else {
          video.pause();
          updatePlayPauseButton();
        }
      });
    
      muteBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        updateMuteButton();
      });
    
      // Keep button states synced if video is played/paused/muted externally
      video.addEventListener('play', updatePlayPauseButton);
      video.addEventListener('pause', updatePlayPauseButton);
      video.addEventListener('volumechange', updateMuteButton);
    });
  }
  setInterval(customizeVideos, 500);

  document.addEventListener('theme:product:added', () => {
    const cartItems = document.querySelectorAll('.cart__item');
    cartItems.forEach(item => {
      const preorderText = item.getAttribute('data-preorder-text');
      const key = item.getAttribute('data-item');
      if (!key || !preorderText) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          properties: {
            [theme.settings.preorderTextKey]: preorderText
          }
        })
      })
      .then(res => res.json())
      .then(cart => {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: {
              cartCount: cart.item_count,
            },
          })
        );
      })
      .catch(err => console.error('Update failed:', err));
    });

  });
  
  // Execute scripts in predictive search results when they are injected
  // Watch for predictive search results being injected (mobile and desktop)
  const setupPredictiveSearchObserver = () => {
    const predictiveSearchResultsContainers = document.querySelectorAll('[data-predictive-search-results]');
    predictiveSearchResultsContainers.forEach((container) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // Check if children were added (new HTML was injected via innerHTML)
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            const scripts = container.querySelectorAll('script');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              if (script.src) {
                newScript.src = script.src;
                newScript.onload = () => script.remove(); // Cleanup
              } else {
                newScript.textContent = script.textContent;
              }
              newScript.type = 'text/javascript';
              document.head.appendChild(newScript);
              script.remove();
            });
          }
        });
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  };

  // Set up observer when DOM is ready or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupPredictiveSearchObserver);
  } else {
    setupPredictiveSearchObserver();
  }

  /**
   * KI-generated watermark
   * Adds a small watermark image to the bottom-right corner of every <img>
   * whose alt text contains the configured indicator text (e.g. "KI-generiert").
   * PhotoSwipe lightbox badges are handled in load-photoswipe.js via the
   * original [data-zoom-image] reference (pswp imgs have no alt text).
   */
  const getKiWatermarkSettings = () => {
    if (!window.theme || !theme.settings) {
      return null;
    }

    const {
      showKiWatermark,
      kiWatermarkImage,
      kiWatermarkIndicator,
      kiWatermarkImageDark,
      kiWatermarkIndicatorDark,
    } = theme.settings;

    if (!showKiWatermark) {
      return null;
    }

    if (!kiWatermarkImage && !kiWatermarkImageDark) {
      return null;
    }

    return {
      kiWatermarkImage,
      kiWatermarkIndicator,
      indicator: kiWatermarkIndicator ? String(kiWatermarkIndicator).toLowerCase() : '',
      kiWatermarkImageDark,
      kiWatermarkIndicatorDark,
      indicatorDark: kiWatermarkIndicatorDark ? String(kiWatermarkIndicatorDark).toLowerCase() : '',
    };
  };

  const isKiGeneratedAlt = (altText, indicator) => {
    if (!altText || !indicator) {
      return false;
    }
    return String(altText).toLowerCase().includes(indicator);
  };

  const resolveKiWatermark = (altText, settings) => {
    if (settings.indicatorDark && isKiGeneratedAlt(altText, settings.indicatorDark)) {
      if (!settings.kiWatermarkImageDark) {
        return null;
      }
      return {
        kiWatermarkImage: settings.kiWatermarkImageDark,
        kiWatermarkIndicator: settings.kiWatermarkIndicatorDark,
        variant: 'dark',
      };
    }
    if (settings.kiWatermarkImage && settings.indicator && isKiGeneratedAlt(altText, settings.indicator)) {
      return {
        kiWatermarkImage: settings.kiWatermarkImage,
        kiWatermarkIndicator: settings.kiWatermarkIndicator,
        variant: 'light',
      };
    }
    return null;
  };

  const getZoomTriggerAlt = (trigger) =>
    trigger.getAttribute('data-image-alt') ||
    (trigger.querySelector('img') && trigger.querySelector('img').getAttribute('alt')) ||
    '';

  const createKiWatermarkBadge = (kiWatermarkImage, kiWatermarkIndicator, className) => {
    const badge = document.createElement('img');
    badge.src = kiWatermarkImage;
    badge.alt = kiWatermarkIndicator;
    badge.className = className;
    badge.setAttribute('data-ki-watermark-badge', 'true');
    return badge;
  };

  const markKiZoomTriggers = (settings) => {
    document.querySelectorAll('[data-zoom-image]').forEach((trigger) => {
      const resolvedWatermark = resolveKiWatermark(getZoomTriggerAlt(trigger), settings);
      if (
        trigger.querySelector('[data-ki-watermark-applied="true"], .ki-watermark-badge:not(.ki-watermark-badge--zoom)') ||
        resolvedWatermark
      ) {
        trigger.setAttribute('data-ki-generated', 'true');
        if (resolvedWatermark) {
          trigger.setAttribute('data-ki-watermark-variant', resolvedWatermark.variant);
        }
      }
    });
  };

  const applyKiGeneratedWatermarks = () => {
    const settings = getKiWatermarkSettings();
    if (!settings) {
      return;
    }

    const images = document.querySelectorAll('img[alt]');
    images.forEach((img) => {
      if (img.dataset.kiWatermarkApplied === 'true') {
        return;
      }
      if (img.classList.contains('ki-watermark-badge')) {
        return;
      }
      if (img.hasAttribute('data-ki-watermark-badge')) {
        return;
      }
      if (img.classList.contains('pswp__img') || img.closest('.pswp')) {
        return;
      }

      const altText = img.getAttribute('alt') || '';
      const resolvedWatermark = resolveKiWatermark(altText, settings);
      if (!resolvedWatermark) {
        return;
      }

      img.dataset.kiWatermarkApplied = 'true';

      const zoomTrigger = img.closest('[data-zoom-image]');
      if (zoomTrigger) {
        zoomTrigger.setAttribute('data-ki-generated', 'true');
        zoomTrigger.setAttribute('data-ki-watermark-variant', resolvedWatermark.variant);
      }

      // Prefer using an enclosing <figure> as container to avoid breaking markup
      let container = img.closest('figure');
      if (container) {
        container.classList.add('ki-watermark-container');
      } else {
        container = img.closest('.ki-watermark-container');
        if (!container) {
          const parent = img.parentNode;
          if (parent && img.computedStyleMap().get('position').value == 'absolute') {
            // If the image is absolutely positioned, use the parent as container
            parent.classList.add('ki-watermark-container');
            container = parent;
          } else {
            // Fallback: wrap image in a span container
            const wrapper = document.createElement('span');
            wrapper.className = 'ki-watermark-container ki-watermark-wrapper';

            if (img.parentNode) {
              img.parentNode.insertBefore(wrapper, img);
              wrapper.appendChild(img);
            }

            container = wrapper;
          }
        }
      }

      // Avoid adding multiple badges
      if (container.querySelector('.ki-watermark-badge')) {
        return;
      }

      container.appendChild(
        createKiWatermarkBadge(
          resolvedWatermark.kiWatermarkImage,
          resolvedWatermark.kiWatermarkIndicator,
          'ki-watermark-badge'
        )
      );
    });

    markKiZoomTriggers(settings);
  };

  const initKiGeneratedWatermarks = () => {
    let scheduled = false;
    const scheduleApply = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        applyKiGeneratedWatermarks();
      });
    };

    // Mark triggers ASAP so zoom.js can read data-ki-generated on first open
    applyKiGeneratedWatermarks();
    setTimeout(scheduleApply, 1000);

    const observer = new MutationObserver(scheduleApply);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKiGeneratedWatermarks);
  } else {
    initKiGeneratedWatermarks();
  }

  /**
   * Alt-text hover tooltip
   * Shows an image's alt text in small type on hover/focus, site-wide.
   * Uses a single shared tooltip element positioned via getBoundingClientRect,
   * so no existing image markup needs to be wrapped or altered.
   */
  const initAltTextTooltip = () => {
    if (!window.theme || !theme.settings || !theme.settings.showImageAltTooltip) return;

    const tooltip = document.createElement('div');
    tooltip.className = 'alt-text-tooltip';
    tooltip.setAttribute('aria-hidden', 'true');
    document.body.appendChild(tooltip);

    let currentTarget = null;

    const isEligible = (img) =>
      !!img &&
      img.tagName === 'IMG' &&
      !!(img.getAttribute('alt') || '').trim() &&
      !img.hasAttribute('data-ki-watermark-badge') &&
      !img.closest('.pswp');

    const positionTooltip = (target) => {
      const rect = target.getBoundingClientRect();
      const left = Math.min(Math.max(rect.left + rect.width / 2, 8), window.innerWidth - 8);

      // Product cards with a cart/quick-add button overlay the image bottom —
      // nudge the tooltip up so it doesn't sit on top of the button.
      let bottomInset = 8;
      const imageWrap = target.closest('.product-item__image');
      const cartBtn =
        imageWrap &&
        imageWrap.querySelector('.quick-add__holder.desktop, .quick-add__button');

      if (cartBtn && window.matchMedia('(min-width: 750px)').matches) {
        const btnRect = cartBtn.getBoundingClientRect();
        const overlap = rect.bottom - btnRect.top;
        if (overlap > 0) {
          bottomInset = overlap + 8;
        }
      }

      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${rect.bottom - bottomInset}px`;
    };

    const show = (img) => {
      currentTarget = img;
      tooltip.textContent = img.getAttribute('alt').trim();
      positionTooltip(img);
      tooltip.classList.add('is-visible');
    };

    const hide = (img) => {
      if (img && img !== currentTarget) return;
      currentTarget = null;
      tooltip.classList.remove('is-visible');
    };

    document.addEventListener('mouseover', (e) => {
      const img = e.target.closest('img');
      if (isEligible(img)) show(img);
    });
    document.addEventListener('mouseout', (e) => hide(e.target.closest('img')));
    document.addEventListener('focusin', (e) => {
      const img = e.target.closest('img');
      if (isEligible(img)) show(img);
    });
    document.addEventListener('focusout', (e) => hide(e.target.closest('img')));

    window.addEventListener('scroll', () => currentTarget && positionTooltip(currentTarget), { passive: true, capture: true });
    window.addEventListener('resize', () => currentTarget && positionTooltip(currentTarget));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAltTextTooltip);
  } else {
    initAltTextTooltip();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
